@if(data.title) {
  <h2 mat-dialog-title>{{data.title}}</h2>
}
<mat-dialog-content>
  <h3>{{ data.message }}</h3>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onClose()">{{data.secondaryButtonText}}</button>
  @if(data.primaryButtonText) {
  <button mat-stroked-button cdkFocusInitial (click)="onConfirm()">{{data.primaryButtonText}}</button>
  }
</mat-dialog-actions>